import axios from "axios";
import NProgress from "nprogress";
import store from "../../store/store";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";

const apiClient = axios.create({
  baseURL: window.__env.api.baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 10000
});

apiClient.interceptors.request.use(config => {
  const token = store.getters["user/getUserTokenFromLocalStorage"];
  if (token != null) {
    config.headers.Authorization = token;
  }
  return config;
});
apiClient.interceptors.response.use(response => {
  NProgress.done();
  if (response.data.responseCode === "92") {
    RouterUtils.changeRouteTo("login");
  }

  return response;
});

export default {
  checkerAuthorizeGlLevel1(payload) {
    return apiClient.post("/glLevel1Checker", JSON.stringify(payload));
  },
  allGlLevel1CheckersQueue(payload) {
    return apiClient.post("/glLevel1Checker", JSON.stringify(payload));
  },
  allGlLevel1(requestBody) {
    return apiClient.post("/glLevel1Read", JSON.stringify(requestBody));
  },
  createGlLevel1(requestBody) {
    return apiClient.post("/glLevel1Create", JSON.stringify(requestBody));
  }
};
